import Animated from 'react-native-reanimated';
import React, { useCallback, useLayoutEffect } from 'react';
import { Alert } from 'react-native';
import { AppView, Button, ButtonGroup, SettingsSection, withAnimatedNavigationHeader, } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import { IconPhone } from 'design-system/icons';
import { SettingsItemContent, SettingsItemDescription, SettingsItemNavigate, SettingsItemTitle, } from 'design-system/SettingsItem';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import VerificationStatusView from 'design-system/VerificationStatusView';
import { HEIGHT } from 'design-system/Button';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { formatPhoneNumber } from 'utils/formatting';
import { useAppSelector } from 'store/hooks';
import { selectUser } from 'reducers/selectors';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import useCreditScoreNavigation from '../hooks/useCreditScoreNavigation';
const strings = {
    alertTitle: 'Hold on 💫',
    alertMissingPhone: 'You need to specify your phone number.',
    phone: 'Phone number',
    verified: 'Verified',
    addPhoneNumber: 'Add...',
    buttonNext: 'Continue',
    title: 'Contact details',
};
const CreditContactDetailsScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const user = useAppSelector(selectUser);
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, [navigation]);
    const phoneNumber = user?.phoneNumber
        ? formatPhoneNumber(user.phoneNumber)
        : '';
    const { navigateToAddress } = useCreditScoreNavigation();
    const changePhoneNumber = useCallback(() => {
        navigation.navigate('PhoneVerification', {
            flow: 'creditScore',
            onSuccess: () => navigation.pop(2),
        });
    }, [navigation]);
    const onSubmit = useCallback(() => {
        if (!phoneNumber) {
            Alert.alert(strings.alertTitle, strings.alertMissingPhone);
            return false;
        }
        navigateToAddress();
        return true;
    }, [navigateToAddress, phoneNumber]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(false);
    const scrollViewStyle = useMarginBottom('paddingBottom', HEIGHT, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} contentContainerStyle={scrollViewStyle}>
            <ScreenInfoHeader title={strings.title}/>
            <SettingsSection noMarginTop>
              <SettingsItemNavigate icon={<IconPhone gradientKey="time"/>} onPress={changePhoneNumber}>
                <SettingsItemContent>
                  <SettingsItemDescription>
                    {strings.phone}
                  </SettingsItemDescription>
                  <SettingsItemTitle {...(!phoneNumber && {
        color: colors.text.placeholder,
    })}>
                    {phoneNumber || strings.addPhoneNumber}
                  </SettingsItemTitle>
                  {!!phoneNumber && (<VerificationStatusView state="verified" label={strings.verified}/>)}
                </SettingsItemContent>
              </SettingsItemNavigate>
            </SettingsSection>
          </Animated.ScrollView>
          <ButtonGroup type="floating">
            <Button brand onPress={onSubmit} title={strings.buttonNext} disabled={!phoneNumber}/>
          </ButtonGroup>
        </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
    headerTintColor: colors.text.primary,
}));
export default CreditContactDetailsScreen;
